module.exports = __webpack_public_path__ + "img/roulette-spades-small.8cdc335d.svg";